// removed by extract-text-webpack-plugin
module.exports = {"primary-button-responsive":"_1_c8xXExg _1jY4uEptA","mobile":"_2sZYE4qoE _2c5r4ui1j","tablet":"_1sAUoBU4i _2gtf48bQr gkiT2Fxe7"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/primary-button-responsive/primary-button-responsive.css
 ** module id = 2148
 ** module chunks = 0
 **/